// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wg_a bhy_b"};